import store from 'lib/store';
import { renderNewComfirmationDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog.helpers';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { AB_FEATURE_NAME } from 'reactApp/components/BuyModalTrial/BuyModalTrial.types';
import { isVkMusicWebSubscription } from 'reactApp/modules/billingData/billingData.types';
import { isVkMusicReward } from 'reactApp/modules/promoTariffs/promoTariffs.types';

export const shouldTrialBeShown = (userEmail: string | null, subscriptionId: string): boolean => {
    const SHOW_COUNT = 4;
    const id = `${userEmail}|${AB_FEATURE_NAME}_${subscriptionId}`;
    const idCount = `${userEmail}|${AB_FEATURE_NAME}_count_${subscriptionId}`;

    const showCount = store.get(idCount) ?? 0;

    if (showCount > SHOW_COUNT) {
        store.remove(id);
        return false;
    }

    const endDate = store.get(id);
    const now = new Date();

    if (!showCount || !endDate || now > endDate) {
        const newEndDate = new Date().setDate(now.getDate() + 1);

        store.set(id, newEndDate);
        store.set(idCount, showCount + 1);

        return true;
    }

    return false;
};

export const showNoTariffDialog = () => {
    renderNewComfirmationDialog({
        dataQAId: 'no-tariff-dialog',
        renderHeader: () => 'Этот тариф для вас недоступен',
        renderContent: () =>
            'Вероятно, сейчас или в прошлом у вас уже была подписка Mail Space, а акция действует только для новых пользователей. Смените аккаунт и\u00A0попробуйте\u00A0ещё\u00A0раз',
        buttons: [EButtonType.cancel],
        cancelButtonText: 'Закрыть',
    });
};

export const isVkMusicSubscription = (subscription) => isVkMusicReward(subscription) || isVkMusicWebSubscription(subscription);
